import { request } from "../../Services/Api"

export const getBusinessDetails = (params) => request.api.get(`/user/business-details/`, params)

export const updateBusinessDetails = ({ body, params }) =>
  request.api.post(`/user/business-details/`, body, { params })

export const getCountries = (params) => request.api.get(`/user/countries/`, params)
